<template>
  <b-container class="min-vh-100">
    <b-navbar type="dark" class="top-navbar pl-0 pr-0">
      <b-container>
        <b-navbar-brand tag="h1" class="mb-0">
          <b-link href="" to="/home" class="text-decoration-none logo-link">
            <b-img
              src="~@/assets/img/logo.png"
              class="d-inline-block"
              height="40px"
              alt="Vello"
            />
            <span class="align-middle font-weight-bold"> Vello</span>
          </b-link>
        </b-navbar-brand>

        <b-navbar-nav>
          <b-nav-item
            class="mt-n1 mr-n2"
            v-if="user && user.profile_photo_url"
            @click="openNavMenu"
          >
            <b-img
              class="rounded-circle border border-pink"
              style="padding: 0.1rem"
              width="50px"
              height="50px"
              :src="user.profile_photo_url"
            />
          </b-nav-item>

          <b-nav-item-dropdown
            ref="menuNav"
            right
            @hide="checkCloseItem($event)"
          >
            <b-dropdown-item href="" to="/account">
              <b-icon-person-circle class="pr-1" /> Account
              <b-icon-chevron-right class="pt-2 pb-1 float-right" />
            </b-dropdown-item>
            <b-dropdown-item href="" to="/account/details/edit">
              <b-icon-pencil class="pr-1" /> Edit Details
              <b-icon-chevron-right class="pt-2 pb-1 float-right" />
            </b-dropdown-item>
            <b-dropdown-item href="" to="/influencer/following">
              <b-icon-people class="pr-1" /> Following
              <b-icon-chevron-right class="pt-2 pb-1 float-right" />
            </b-dropdown-item>
            <b-dropdown-item href="" to="/influencer/vip">
              <b-icon-star-half class="pr-1" /> VIP Influencers
              <b-icon-chevron-right class="pt-2 pb-1 float-right" />
            </b-dropdown-item>
            <b-dropdown-item href="" to="/account/subscriptions">
              <b-icon-credit-card class="pr-1" /> Subscriptions
              <b-icon-chevron-right class="pt-2 pb-1 float-right" />
            </b-dropdown-item>
            <b-dropdown-item href="" to="/account/transactions">
              <b-icon-clock class="pr-1" /> Charge History
              <b-icon-chevron-right class="pt-2 pb-1 float-right" />
            </b-dropdown-item>
            <b-dropdown-item
              href=""
              to="/account/pricing/edit"
              v-if="user && user.influencer_status === 'approved'"
            >
              <b-icon-gear class="pr-1" /> Manage Pricing
              <b-icon-chevron-right class="pt-2 pb-1 float-right" />
            </b-dropdown-item>
            <b-dropdown-item
              @click.prevent="openSub()"
              v-if="user && user.influencer_status === 'approved'"
            >
              <b-icon-cash-stack class="pr-1" /> Payments
            </b-dropdown-item>

            <b-dd-group v-if="toggleSubmenu">
              <b-dd-item :to="{ name: 'account.payouts-bank' }">
                <template #default>
                  <div class="pl-2" title="60 Day Payments">
                    <b-icon-bank class="pr-1 pb-1" style="height: 16px" /> Bank
                    Account <br /><small
                      class="text-grey"
                      style="padding-left: 22px"
                      >60 Day Payments</small
                    >
                    <b-icon-chevron-right class="pt-2 pb-1 float-right" />
                  </div>
                </template>
              </b-dd-item>
              <b-dd-item :to="{ name: 'account.payouts-page' }">
                <template #default>
                  <div class="pl-2" title="Instant Payments">
                    <svg
                      viewBox="0 0 32 32"
                      height="17px"
                      width="17px"
                      class="p-0 mt-n1"
                      style="margin-left: -2px; margin-right: 2px"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill="#FF3D67"
                        d="M 16.515625 4 C 10.735625 4 7 7.1135938 7 11.933594 C 7 16.706594 11.288953 18.129313 14.126953 19.070312 C 15.402953 19.493313 16.989 20.018109 17 20.537109 C 16.992 20.938109 16.042562 21 15.476562 21 C 13.590563 21 10.698359 20.220516 8.4433594 19.103516 L 7 18.388672 L 7 26.185547 L 7.6113281 26.441406 C 9.9583281 27.427406 12.707297 27.995 15.154297 28 C 21.319297 28 25 25.158391 25 20.400391 C 25 15.208391 20.591781 13.797281 17.675781 12.863281 C 16.609781 12.521281 15 12.005219 15 11.574219 C 15 11.345219 15.000469 11 16.230469 11 C 18.079469 11 20.652281 11.765375 22.488281 12.859375 L 24 13.761719 L 24 5.546875 L 23.363281 5.2988281 C 21.207281 4.4608281 18.776625 4 16.515625 4 z M 16.515625 6 C 18.314625 6 20.237 6.3276875 22 6.9296875 L 22 10.361328 C 20.114 9.5223281 17.953469 9 16.230469 9 C 13.315469 9 13 10.800219 13 11.574219 C 13 13.465219 14.975406 14.098578 17.066406 14.767578 C 20.541406 15.880578 23 16.934391 23 20.400391 C 23 25.453391 17.51325 26 15.15625 26 C 13.17525 25.996 10.967 25.576797 9 24.841797 L 9 21.537109 C 10.993 22.334109 13.465563 23 15.476562 23 C 18.530563 23 18.997 21.465969 19 20.542969 L 19 20.537109 L 19 20.53125 C 18.992 18.57525 16.934859 17.893875 14.755859 17.171875 C 11.385859 16.053875 9 15.024594 9 11.933594 C 9 8.2725937 11.879625 6 16.515625 6 z"
                      />
                    </svg>
                    Stripe <br /><small
                      class="text-grey"
                      style="padding-left: 22px"
                      >Instant Payments</small
                    >
                    <b-icon-chevron-right class="pt-2 pb-1 float-right" />
                  </div>
                </template>
              </b-dd-item>
              <b-dd-divider></b-dd-divider>
            </b-dd-group>
            <b-dropdown-item
              href=""
              @click="togglePostModal(true)"
              v-if="user && user.influencer_status === 'approved'"
            >
              <b-icon-camera-video class="pr-1" /> Post Video
            </b-dropdown-item>

            <b-dropdown-item href="" @click="logout">
              <b-icon-power class="pr-1" /> Logout
              <b-icon-chevron-right class="pt-2 pb-1 float-right" />
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-container>
    </b-navbar>

    <b-container class="px-0 pt-2 pt-md-4 min-vh-100">
      <b-row>
        <b-col>
          <slot />
        </b-col>
      </b-row>
    </b-container>

    <b-container class="p-0 pt-5 pb-4 mt-5">
      <b-row class="grey-light">
        <b-col class="text-left">
          <small>
            <small class="cursor" @click="openLink(links.policy)">
              Privacy Policy
            </small>
            &nbsp;&middot;&nbsp;
            <small class="cursor" @click="openLink(links.terms)">
              Terms of Use
            </small>
          </small>
        </b-col>
        <b-col class="text-right">
          <small>
            <small>&copy; COPYRIGHT VELLO {{ yearToday }}</small>
          </small>
        </b-col>
      </b-row>
    </b-container>
    <PostVideoModal />
  </b-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import PostVideoModal from '@/views/components/PostVideoModal'

export default {
  components: { PostVideoModal },
  data() {
    return {
      links: {
        policy: '',
        terms: '',
      },
      closeItem: true,
      toggleSubmenu: false,
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    yearToday: function () {
      return new Date().getFullYear()
    },
  },

  methods: {
    ...mapMutations('feed', ['togglePostModal']),
    ...mapActions({
      logout: 'auth/logout',
    }),

    openNavMenu() {
      this.$refs.menuNav.$el.children[0].click()
    },

    openLink(link) {
      window.location = link
    },

    openSub() {
      this.closeItem = false
      this.toggleSubmenu = !this.toggleSubmenu
    },

    async checkCloseItem(e) {
      if (!this.closeItem) {
        e.preventDefault()
        this.closeItem = true
      } else {
        this.toggleSubmenu = false
      }
    },
  },

  mounted() {
    this.$refs.menuNav.$el.children[0].classList.add(
      'v-center',
      'h-100',
      'pr-0'
    )

    this.links.policy = process.env.VUE_APP_POLICY_LINK
    this.links.terms = process.env.VUE_APP_TERMS_LINK
  },
}
</script>

<style lang="scss">
.logo-link {
  color: white;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: #ff0058;
  }
}
</style>
